<template>
  <div class="page flex-col">
    <SideBar ref="sidebarRef" class="hidden-sidebar" />
    <div class="main-container">
      <!-- 新增模糊背景层 -->
      <div class="backdrop-layer"></div>

      <!-- 左侧边栏（保持原结构） -->
      <div class="sidebar">
        <div class="filter-section">
          <div class="filter-title">筛选条件</div>
          
          <!-- 面试时间 -->
          <div class="filter-group">
            <div class="group-title">面试时间</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.today">
                <span>今天</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.threeDays">
                <span>3天内</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.oneWeek">
                <span>一周内</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="timeFilters.oneMonth">
                <span>一月内</span>
              </label>
            </div>
          </div>

          <!-- 学校 -->
          <div class="filter-group">
            <div class="group-title">学校</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="schoolFilters.top985">
                <span>985</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="schoolFilters.top211">
                <span>211</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="schoolFilters.firstTier">
                <span>一本</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="schoolFilters.secondTier">
                <span>二本</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="schoolFilters.qs200">
                <span>QS前200</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="schoolFilters.qs500">
                <span>QS前500</span>
              </label>
            </div>
          </div>

          <!-- 学历 -->
          <div class="filter-group">
            <div class="group-title">学历</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.highSchool">
                <span>初高中</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.bachelor">
                <span>本科</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.master">
                <span>研究生</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.phd">
                <span>博士</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="educationFilters.adult">
                <span>成人自考</span>
              </label>
            </div>
          </div>

          <!-- 工作性质 -->
          <div class="filter-group">
            <div class="group-title">工作性质</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="workTypeFilters.intern">
                <span>实习生</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="workTypeFilters.partTime">
                <span>兼职</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="workTypeFilters.fullTime">
                <span>全职</span>
              </label>
            </div>
          </div>

          <!-- 岗位类别 -->
          <div class="filter-group">
            <div class="group-title">岗位类别</div>
            <div class="checkbox-group">
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.internet">
                <span>互联网/AI</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.product">
                <span>产品</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.sales">
                <span>销售</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.finance">
                <span>财务/审计/税务</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.service">
                <span>家教/生活服务</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.catering">
                <span>餐饮</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.electronics">
                <span>电子/电气/通信</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.hr">
                <span>人力/行政/法务</span>
              </label>
              <label class="checkbox-item">
                <input type="checkbox" v-model="jobTypeFilters.manufacturing">
                <span>生产制造</span>
              </label>
            </div>
          </div>
        </div>
        
        
     
      </div>

      <!-- 修改后的主内容区 -->
      <div class="content-body">
        <div class="top-bar">
          <div class="category-tags">
            <div class="category-tag active">产品</div>
            <div class="category-tag">互联网/AI</div>
          </div>
          <div class="search-bar">
            <input 
              type="text" 
              class="search-input" 
              placeholder="搜索候选人" 
              v-model="searchQuery"
              @keyup.enter="handleSearch"
            >
            <div class="search-icon-container" @click="handleSearch">
              <div class="search-icon">
                <img src="./assets/img/search.png" class="search-icon-img" alt="搜索图标" />
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="loading" class="loading-indicator">
          <span style="font-size: 1.2vw;color: #999;">加载中...</span>
        </div>
        
        <div v-else-if="candidates.length === 0" class="no-data">
          <span style="font-size: 1.2vw;color: #999;">暂无候选人</span>
        </div>
        
        <div class="candidate-list">
          <div class="candidate-card" v-for="(candidate, index) in filteredCandidates" :key="index" @click="viewCandidate(candidate)">
            <div class="candidate-header">
              <div class="candidate-avatar">
                <img :src="candidate.avatar" alt="候选人头像" />
                <div class="gender-icon" :class="candidate.gender === 'male' ? 'male' : 'female'">
                  <span v-if="candidate.gender === 'male'" style="color: white; font-size: 0.6vw;">♂</span>
                  <span v-else style="color: white; font-size: 0.6vw;">♀</span>
                </div>
              </div>
              <div class="candidate-info">
                <div class="candidate-name">{{ candidate.name }}</div>
                <div class="candidate-basic">{{ candidate.phone }} | {{ candidate.age }}岁 | {{ candidate.school }} | {{ candidate.education }} | {{ candidate.experience }}</div>
              </div>
            </div>
            
            <div class="candidate-tags">
              <div class="tag" v-for="(tag, tagIndex) in candidate.tags" :key="tagIndex">{{ tag }}</div>
            </div>
            
            <div class="candidate-position">
              <div class="position-label">面试岗位：</div>
              <div class="position-value">{{ candidate.position }}</div>
            </div>
            
            <div class="candidate-time">
              <div class="time-label">面试时间：</div>
              <div class="time-value">{{ candidate.interviewDate }}</div>
            </div>
            
            <div class="candidate-duration">
              <div class="duration-label">面试时长：</div>
              <div class="duration-value">{{ candidate.interviewDuration }}</div>
            </div>
            
            <div class="score-circle" :style="{ background: `conic-gradient(#B16EF9 0% ${candidate.score}%, #eee ${candidate.score}% 100%)` }">
              <div class="score-inner">
                <div class="score-value">{{ candidate.score }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 模态框组件 -->
    <div class="modal-overlay" v-if="isModalVisible" @click.self="cancelModal">
      <div class="modal-container">
        <!-- 编辑名称模态框 -->
        <div v-if="modalType === 'edit'" class="modal-content">
          <div class="modal-title">修改名称</div>
          <input 
            type="text" 
            class="modal-input" 
            v-model="editingName" 
            ref="modalEditInput"
            placeholder="请输入新名称"
          />
          <div class="modal-buttons">
            <button class="modal-btn confirm-btn" @click="confirmEdit">确定</button>
            <button class="modal-btn cancel-btn" @click="cancelModal">取消</button>
          </div>
        </div>
        
        <!-- 删除确认模态框 -->
        <div v-if="modalType === 'delete'" class="modal-content">
          <div class="modal-title">您确定要删除吗？</div>
          <div class="modal-buttons">
            <button class="modal-btn confirm-btn" @click="confirmDelete">确定</button>
            <button class="modal-btn cancel-btn" @click="cancelModal">取消</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 在底部添加UserProfileEditor组件 -->
    <user-profile-editor
      :visible.sync="showProfileEditor"
      :user-info="userInfo"
      @submit="handleProfileSubmit"
      @cancel="handleProfileCancel"
      @avatar-updated="handleAvatarUpdate"
    />
  </div>
</template>


<script>
import { getInterviewData } from '@/api/mianshilishi.js'
import { mapState } from 'vuex'
import SideBar from '@/components/SideBar/index.vue';
import SlidableRing from '@/components/SlidableRing/index.vue'
import UserProfileEditor from '@/components/UserProfileEditor/index.vue';
import { getUserInterviewList,deleteUserInterview,updateUserInterview,addUserInterview } from '@/api/mianshilishi.js' // 引入API函数
import { test_uesrinfo } from '@/api/user'
import { getToken } from '@/store/local/auth'

// 模拟接口响应数据
const mockApiResponse = {
  code: 0,
  msg: "获取成功",
  data: {
    count: 5,
    lists: [
      {
        id: 1001,
        interview_name: "产品经理面试 - 阿里巴巴",
        create_time: "2023-11-15T14:30:00",
        update_time: "2023-11-15T16:00:00",
        interview_time: 90, // 面试时长（分钟）
        jd_url: "https://example.com/jd/1001",
        resume_url: "https://example.com/resume/1001",
        user_id: 10086
      },
      {
        id: 1002,
        interview_name: "UI设计师面试 - 腾讯",
        create_time: "2023-11-10T10:00:00",
        update_time: "2023-11-10T11:15:00",
        interview_time: 75,
        jd_url: "https://example.com/jd/1002",
        resume_url: "https://example.com/resume/1002",
        user_id: 10086
      },
      {
        id: 1003,
        interview_name: "前端开发工程师 - 字节跳动",
        create_time: "2023-11-05T09:30:00",
        update_time: "2023-11-05T10:45:00",
        interview_time: 75,
        jd_url: "https://example.com/jd/1003",
        resume_url: "https://example.com/resume/1003",
        user_id: 10086
      },
      {
        id: 1004,
        interview_name: "数据分析师 - 网易",
        create_time: "2023-10-28T16:00:00",
        update_time: "2023-10-28T17:30:00",
        interview_time: 90,
        jd_url: "https://example.com/jd/1004",
        resume_url: "https://example.com/resume/1004",
        user_id: 10086
      },
      {
        id: 1005,
        interview_name: "后端开发工程师 - 小米",
        create_time: "2023-10-20T11:00:00",
        update_time: "2023-10-20T12:30:00",
        interview_time: 90,
        jd_url: "https://example.com/jd/1005",
        resume_url: "https://example.com/resume/1005",
        user_id: 10086
      }
    ]
  }
};

export default {
  components: {
    SlidableRing,
    SideBar,
    UserProfileEditor
  },
  data() {
    return {
      historyItems: [], // 改为空数组，将从API获取
      searchQuery: '',
      hoveredCard: null,
      editingCard: null,
      editingName: '',
      username: '',
      // 模态框相关状态
      isModalVisible: false,
      modalType: null,
      editingItemId: null,
      deleteItemId: null,
      
      // 分页相关
      loading: false,
      pagination: {
        page_no: 1,//当前页码
        page_size: 12,//每页显示条数
        total: 0//总条数（从API获取）
      },
      
      // 添加编辑资料相关的数据
      showProfileEditor: false,
      userInfo: {
        avatar: '',
        name: '',
        email: '',
        phone: '',
        wechat: ''
      },
      timeFilters: {
        today: false,
        threeDays: false,
        oneWeek: false,
        oneMonth: false
      },
      schoolFilters: {
        top985: false,
        top211: false,
        firstTier: false,
        secondTier: false,
        qs200: false,
        qs500: false
      },
      educationFilters: {
        highSchool: false,
        bachelor: false,
        master: false,
        phd: false,
        adult: false
      },
      workTypeFilters: {
        intern: false,
        partTime: false,
        fullTime: false
      },
      jobTypeFilters: {
        internet: false,
        product: false,
        sales: false,
        finance: false,
        service: false,
        catering: false,
        electronics: false,
        hr: false,
        manufacturing: false
      },
      candidates: [
        {
          id: 1,
          name: '王生安',
          gender: 'male',
          avatar: require('./assets/img/FigmaDDSSlicePNG5a3b99fc6f8a3105bd975a37071449bc.png'),
          phone: '15988889999',
          age: 40,
          school: '香港大学',
          education: '硕士',
          experience: '17年',
          position: 'B端产品经理',
          interviewDate: '2025年02月21日',
          interviewDuration: '30分钟',
          score: 95,
          tags: ['0-1产品经验', 'B端', '团队核心', '产品专家']
        },
        {
          id: 2,
          name: '李鑫潇',
          gender: 'female',
          avatar: require('./assets/img/FigmaDDSSlicePNG5a3b99fc6f8a3105bd975a37071449bc.png'),
          phone: '13088889999',
          age: 22,
          school: '清华大学',
          education: '本科',
          experience: '应届生',
          position: '电商产品经理',
          interviewDate: '2025年02月21日',
          interviewDuration: '30分钟',
          score: 85,
          tags: ['大厂经验', 'Figma', 'C端']
        },
        {
          id: 3,
          name: '薛佛世',
          gender: 'female',
          avatar: require('./assets/img/FigmaDDSSlicePNG5a3b99fc6f8a3105bd975a37071449bc.png'),
          phone: '13188889999',
          age: 24,
          school: '剑桥大学',
          education: '硕士',
          experience: '应届生',
          position: 'AI产品经理',
          interviewDate: '2025年02月21日',
          interviewDuration: '15分钟',
          score: 85,
          tags: ['大厂经验', 'Axure', 'C端']
        },
        {
          id: 4,
          name: '汤辟邦',
          gender: 'male',
          avatar: require('./assets/img/FigmaDDSSlicePNG5a3b99fc6f8a3105bd975a37071449bc.png'),
          phone: '15688889999',
          age: 30,
          school: '昆士兰大学',
          education: '本科',
          experience: '8年',
          position: '大模型产品经理',
          interviewDate: '2025年02月21日',
          interviewDuration: '30分钟',
          score: 80,
          tags: ['团队负责人', 'C端', 'B端']
        },
        {
          id: 5,
          name: '潘恩依',
          gender: 'female',
          avatar: require('./assets/img/FigmaDDSSlicePNG5a3b99fc6f8a3105bd975a37071449bc.png'),
          phone: '18988889999',
          age: 22,
          school: '卡内基梅隆大学',
          education: '本科',
          experience: '应届生',
          position: 'B端产品经理',
          interviewDate: '2025年02月21日',
          interviewDuration: '30分钟',
          score: 80,
          tags: ['大厂经验', 'G端', 'C端']
        },
        {
          id: 6,
          name: '张顺',
          gender: 'male',
          avatar: require('./assets/img/FigmaDDSSlicePNG5a3b99fc6f8a3105bd975a37071449bc.png'),
          phone: '17888889999',
          age: 32,
          school: '悉尼大学',
          education: '本科',
          experience: '10年',
          position: 'AI产品经理',
          interviewDate: '2025年02月21日',
          interviewDuration: '30分钟',
          score: 80,
          tags: ['团队骨干', 'C端']
        }
      ]
    };
  },
  computed: {
    ...mapState('user', ['avatar']),
    filteredHistoryItems() {
      if (!this.searchQuery) return this.historyItems;
      return this.historyItems.filter(item => 
        item.name && item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    filteredCandidates() {
      if (!this.searchQuery) return this.candidates;
      const query = this.searchQuery.toLowerCase();
      return this.candidates.filter(candidate => 
        candidate.name.toLowerCase().includes(query) || 
        candidate.position.toLowerCase().includes(query) ||
        candidate.school.toLowerCase().includes(query)
      );
    }
  },
  created() {
    // 检查是否有有效的token
    if (!getToken()) {
      this.$message.warning('您尚未登录或登录已过期，请重新登录')
      this.$router.push('/store/entry') // 导航到登录页
      return
    }
    
    this.fetchInterviewList();
    test_uesrinfo().then(response=>{
      // 使用nickname，如果为空则使用account
      this.username = response.data.data.nickname || response.data.data.account || '用户'
      
      // 同样更新userInfo中的name值
      this.userInfo = {
        name: response.data.data.nickname || response.data.data.account || '',
        avatar: response.data.data.avatar || '',
        email: response.data.data.email || '',
        phone: response.data.data.phone || '',
        wechat: response.data.data.wechat || ''
      };
    })
  },
  methods: {
    // 从API获取面试历史列表
    async fetchInterviewList() {
      try {
        if (!getToken()) {
          this.$message.warning('身份验证已过期，请重新登录')
          return
        }
        
        this.loading = true;
        const params = {
          page_no: this.pagination.page_no,
          page_size: this.pagination.page_size,
          ...(this.searchQuery && { interviewName: this.searchQuery })
        };
        
        // 使用真实API
        const response = await getUserInterviewList(params);
        
        console.log('API是否成功调用:', response.status === 200 ? '是' : '否');
        console.log('响应数据:', response.data);
        console.log('响应code:', response.data.code);
        console.log('data中的lists:', response.data.data?.lists);
        
        // 正确访问嵌套数据结构
        if (response.data && response.data.code === 1) {
          // 确保lists存在
          const lists = response.data.data?.lists || [];
          
          console.log('找到的记录数量:', lists.length);
          
          // 转换API返回的数据格式
          this.historyItems = lists.map(item => ({
            id: item.id,
            name: item.interview_name || '未命名',
            time: item.create_time,
            score: this.calculateScore(item),
          }));
          
          // 更新分页信息
          this.pagination.total = response.data.data?.count || 0;
        } else {
          console.error('获取面试历史失败:', response.msg);
        }
      } catch (error) {
        console.error('获取面试历史出错:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 根据面试数据计算分数（示例逻辑，根据实际需求调整）
    calculateScore(item) {
      // 假设分数来自其他地方，这里模拟一个随机分数
      return Math.floor(Math.random() * 31) + 70; // 70-100之间的随机数
    },
    
    // 搜索处理
    handleSearch() {
      this.pagination.page_no = 1; // 重置到第一页
      this.fetchInterviewList();
    },
    
    // 修改确认编辑的方法
    async confirmEdit() {
      if (this.editingName.trim()) {
        try {
          console.log('修改面试记录id：',this.editingItemId)
          // 正确调用方式，传递id和name两个参数
          const response = await updateUserInterview(
            this.editingItemId, 
            this.editingName
          );
          console.log('修改面试记录响应：',response)
          // 更新本地数据
          const index = this.historyItems.findIndex(i => i.id === this.editingItemId);
          if (index !== -1) {
            this.historyItems[index].name = this.editingName.trim();
          }
          
          this.$message.success('修改成功');
        } catch (error) {
          console.error('修改面试名称失败:', error);
          this.$message.error('修改失败，请重试');
        }
      }
      this.cancelModal();
    },
    
    async getInterviewData(id) {
      const response = await getInterviewData(id);
      console.log('获取面试数据响应：',response)
    },
    // 修改确认删除的方法
    async confirmDelete() {
      try {
        console.log('删除面试记录id：',this.deleteItemId)
        // 这里应该有一个删除面试记录的API调用
        const response = await deleteUserInterview(this.deleteItemId);
        console.log('删除面试记录响应：',response)
        // 更新本地数据
        this.historyItems = this.historyItems.filter(item => item.id !== this.deleteItemId);
        
        this.$message.success('删除成功');
      } catch (error) {
        console.error('删除面试记录失败:', error);
        this.$message.error('删除失败，请重试');
      }
      this.cancelModal();
    },
    
    
    // 其他现有方法...
    formatDate(dateString) {
      if (!dateString) return ''; // 处理空字符串或 null
      
      try {
        const originalDate = new Date(dateString);
        
        // 检查日期是否有效
        if (isNaN(originalDate.getTime())) {
           console.error("无效的日期字符串:", dateString);
           return "无效日期"; 
        }

        // 计算8小时的毫秒数 (从9小时改为8小时)
        const eightHoursInMillis = 8 * 60 * 60 * 1000;

        // 创建一个新的Date对象，时间戳加上8小时
        const adjustedDate = new Date(originalDate.getTime() + eightHoursInMillis);

        // 格式化调整后的日期
        const year = adjustedDate.getFullYear();
        const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
        const day = String(adjustedDate.getDate()).padStart(2, '0');
        const hours = String(adjustedDate.getHours()).padStart(2, '0');
        const minutes = String(adjustedDate.getMinutes()).padStart(2, '0');
        
        return `${year}/${month}/${day} ${hours}:${minutes}`;
      } catch (error) {
        console.error("格式化日期时出错:", error, "日期字符串:", dateString);
        return "日期错误"; // 返回错误提示
      }
    },
    goToHome() {
      this.$router.push('//store/dashboard/profile');
    },
    editProfile() {
      this.showProfileEditor = true;
    },
    feedback() {
      // 调用SideBar组件的openFeedbackModal方法
      this.$refs.sidebarRef.openFeedbackModal();
    },
    logout() {
      // 通过Vuex触发登出操作
      this.$store.dispatch('user/logout').then(() => {
        this.$message.success('已成功退出登录');
        // 重定向到登录页面
        this.$router.push('/store/entry');
      }).catch(error => {
        console.error('退出登录失败:', error);
        this.$message.error('退出登录失败，请重试');
      });
    },
    viewHistory(item) {
      if (!this.editingCard) {
        // 方案1：使用查询参数而不是路径参数
        this.$router.push({name:'Interview_Analysis',params:{id:item.id}})
        
        // 或者方案2：尝试其他可能的路径格式
        // this.$router.push(`/store/interview_analysis/${item.id}`); // 小写尝试
        
        // 或者方案3：通过Vuex存储ID，然后跳转到分析页面
        // this.$store.commit('interviewState/SET_CURRENT_INTERVIEW_ID', item.id);
        // this.$router.push('/store/Interview_Analysis');
      }
    },
    startEditing(item) {
      this.editingItemId = item.id;
      this.editingName = item.name;
      this.modalType = 'edit';
      this.isModalVisible = true;
      
      // 在下一个事件循环中聚焦输入框
      this.$nextTick(() => {
        if (this.$refs.modalEditInput) {
          this.$refs.modalEditInput.focus();
        }
      });
    },
    saveEditing(item) {
      if (this.editingName.trim()) {
        const index = this.historyItems.findIndex(i => i.id === item.id);
        if (index !== -1) {
          this.historyItems[index].name = this.editingName.trim();
        }
      }
      this.editingCard = null;
    },
    deleteCard(id) {
      this.deleteItemId = id;
      this.modalType = 'delete';
      this.isModalVisible = true;
    },
    cancelModal() {
      this.isModalVisible = false;
      this.modalType = null;
      this.editingItemId = null;
      this.deleteItemId = null;
    },
    // 添加处理个人资料编辑的方法
    handleProfileSubmit(formData) {
      // 这里可以添加API调用来更新用户资料
      console.log('提交的个人资料:', formData);
      
      // 更新本地数据
      this.userInfo = { ...this.userInfo, ...formData };
      this.username = formData.name;
      
      this.$message.success('个人资料更新成功');
      this.showProfileEditor = false;
    },
    
    handleProfileCancel() {
      this.showProfileEditor = false;
    },
    
    handleAvatarUpdate(newAvatarUrl) {
      this.userInfo.avatar = newAvatarUrl;
    },
    viewCandidate(candidate) {
      // 查看候选人详情
      console.log('查看候选人详情:', candidate);
      this.$router.push({
        name: 'lanhu_houxuanrenmianshixiangqing',
        params: { id: candidate.id }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    // 如果是从分析页面返回，则刷新页面
    if (from.path && from.path.includes('Interview_Analysis')) {
      next(vm => {
        // 等路由完成后刷新页面
        window.location.reload();
      });
    } else {
      next();
    }
  },
  watch: {
    '$route'(to, from) {
      // 如果当前路径是面试历史页面，且来源是分析页面
      if (to.path.includes('interview_mianshilishi') && from.path.includes('Interview_Analysis')) {
        // 使用setTimeout确保路由完成跳转后再刷新
        setTimeout(() => {
          window.location.reload();
        }, 50);
      }
    }
  }
};
</script>

<style scoped lang="css" src="./assets/index.response.css" />
<style scoped lang="css" src="./assets/candidate.css" />
<style scoped>
/* 自定义样式 */
.left {
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: linear-gradient(180deg, rgba(177, 110, 249, 0.10) 0%, rgba(126, 180, 235, 0.10) 100%);
  border-radius: 26px;
  border: 1px solid #A47FF6;
  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(27.85px);
  margin-right: -1.5vw;
}

.div42 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-left: 20px;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

.image5 {
  width: 100%;
  height: 60%;
  object-fit: cover;
  border-radius: 25.92px 25.92px 0 0;
}

.frame-1 {
  padding: 20px;
  overflow-y: auto;
  height: calc(100% - 80px);
}

.vector-1 {
  width: 100%;
  height: auto;
}

.div13 {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}

.div14 {
  color: #FFFFFF;
  text-align: center;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-decoration: none;
  line-height: 32px;
}

._1 {
  position: absolute;
  width: 13vw;
  min-width: 180px;
  max-width: 300px;
  height: auto;
  top: 3vh;
  left: 0;
  z-index: 0;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  height: 28vh;
  width: 22vw;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 1vw;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
  padding: 1.5vw;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(126, 180, 235, 0.3);
}

.modal-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-title {
  font-size: 1.2vw;
  color: #444;
  margin-bottom: 1.5vh;
  text-align: center;
}

.modal-input {
  width: 90%;
  height: 3.5vh;
  border: none;
  border-radius: 0.5vw;
  padding: 0 1vw;
  margin-bottom: 2vh;
  font-size: 1vw;
  background: rgba(255, 255, 255, 0.8);
  border-bottom: 2px solid #7EB4EB;
  outline: none;
  text-align: center;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-top: 8vh;
}

.modal-btn {
  width: 7vw;
  height: 5vh;
  border: none;
  border-radius: 2vh;
  font-size: 0.9vw;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-btn {
  background: linear-gradient(90deg, #7EB4EB, #B16EF9);
  color: white;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  color: #666;
}

.modal-btn:hover {
  transform: translateY(-0.2vh);
  box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}

.user-profile {
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 2vw;
}

.avatar {
  width: 3.5vw;
  height: 3.5vw;
  min-width: 3.5vw;
  margin-right: 0.1vw;
  border-radius: 50%;
  overflow: hidden;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.username {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-card {
  border: 1px solid #7EB4EB !important;
  border-image: none !important;
}

.sidebar {
  border: none !important;
  border-radius: 0 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  width: 20% !important;
  backdrop-filter: blur(27.85px) !important;
}

.main-container {
  border: 1.3px solid #7EB4EB !important;
  border-image: none !important;
  
}
</style>
